document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll(".ts-projects__sticky-image");
  const blocks = document.querySelectorAll(".ts-projects__content-block");

  function handleScroll() {
    let closestIndex = 0;
    let minDistance = Infinity;

    blocks.forEach((block, index) => {
      const rect = block.getBoundingClientRect();
      const distance = Math.abs(rect.top - window.innerHeight * 0.05);

      if (distance < minDistance) {
        minDistance = distance;
        closestIndex = index;
      }
    });

    images.forEach((img, i) => {
      img.style.opacity = i === closestIndex ? 1 : 0;
    });
  }

  window.addEventListener("scroll", handleScroll);
  handleScroll();

  const popupOpener = document.querySelectorAll(".ts-projects-js-btn");
  const body = document.querySelector("body");

  popupOpener.forEach((btn) => {
    btn.addEventListener("click", () => {
      const popup = document.querySelector(`[data-popup="${btn.getAttribute("data-trigger")}"]`);
      const popupCloser = popup.querySelector(".ts-projects__popup-close");

      if (popup) {
        popup.classList.add("active");
        body.classList.add("shaded");

        popupCloser.addEventListener("click", () => {
          popup.classList.remove("active");
          body.classList.remove("shaded");
        });
      }
    });
  });

  document.addEventListener("click", function (e) {
    const popup = e.target.closest("[data-popup]");
    const clickedInsideSlider = e.target.closest(".TSProjectsPopupSlider");
    const clickedInsideControls = e.target.closest(".ts-projects__popup-controls");

    if (popup && !clickedInsideSlider && !clickedInsideControls) {
      popup.classList.remove("active");
      body.classList.remove("shaded");
    }
  });
});
